import { useQuery } from "@tanstack/react-query"
import { api } from "@/lib/api-client"

export interface SearchResult {
  entity_type: string
  entity_id: string
  title: string
  subtitle: string | null
  url: string
}

export function useGlobalSearch(query: string, types?: string[]) {
  return useQuery({
    queryKey: ["search", query, types],
    queryFn: () => {
      const params = new URLSearchParams({ q: query })
      if (types?.length) params.set("types", types.join(","))
      return api.get<{ data: SearchResult[] }>(`/api/v1/search?${params}`)
    },
    enabled: query.length >= 2,
    staleTime: 30_000,
    placeholderData: (prev) => prev,
  })
}
